export interface BohiioMarketplaceLinks {
  base: string;
  tendency: string;
  verificatioRequest: string;
  plans: string;
  map: string;
  privacy: string;
  terms: string;
  aboutUs: string;
  addProperty: string;
  notifications: string;
  configuration: string;
  favorites: string;
  profile: (username: string) => string;
}

export function getMarketplaceLinks(BOHIIO_MARKETPLACE_URL?: string) {
  return {
    base: `${BOHIIO_MARKETPLACE_URL}`,
    tendency: `${BOHIIO_MARKETPLACE_URL}/tendency`,
    verificatioRequest: `${BOHIIO_MARKETPLACE_URL}/request-verification`,
    plans: `${BOHIIO_MARKETPLACE_URL}/plans`,
    map: `${BOHIIO_MARKETPLACE_URL}/map`,
    privacy: `${BOHIIO_MARKETPLACE_URL}/privacy`,
    terms: `${BOHIIO_MARKETPLACE_URL}/terms`,
    aboutUs: `${BOHIIO_MARKETPLACE_URL}/about-us`,
    addProperty: `${BOHIIO_MARKETPLACE_URL}/add-property`,
    notifications: `${BOHIIO_MARKETPLACE_URL}/notifications`,
    configuration: `${BOHIIO_MARKETPLACE_URL}/profile-configuration`,
    favorites: `${BOHIIO_MARKETPLACE_URL}/favorites`,
    profile: (username: string) =>
      `${BOHIIO_MARKETPLACE_URL}/profile/${username}`,
  } as BohiioMarketplaceLinks;
}

export const ROUTES = {
  index: "/",
  login: "/login",
  signup: "/sign-up",
  logout: "/logout",
  resetPassword: "/reset-password",
  forgotPassword: "/forgot-password",
  verifyAccount: "/verify-account",
  verifyEmail: "/verify-email",
  verifyUsername: "/verify-username",
};
